import { useSearchParams } from 'react-router-dom'
import { Header } from '../../components/header'
import { Footer } from '../../components/footer'
import { Banner } from '../../components/bannerHome'
import { QuickAccess } from '../../components/quickAccess'
import Doente from '../../assets/images/sickPerson.jpg'
import Cinza from '../../assets/images/grey.png'
import './style.css'

export function SelecionarTipo() {
  const [searchParams] = useSearchParams()
  const action = searchParams.get('action')

  const cards = [
    {
      title: 'Portal do Paciente',
      image: Doente,
      route: action === 'criar-conta' ? '/criar-conta-paciente' : '/login-paciente'
    },
    {
      title: 'Portal Funcionário',
      image: Cinza,
      route: action === 'criar-conta' ? '/criar-conta-funcionario' : '/login-funcionario'
    }
  ]

  return (
     <div className="select-role-page">
       <Header />
       <main>
         <section>
           <Banner
             title="VidaPlus"
             subtitle="Sua solução completa para uma vida mais saudável"
           />
         </section>
         <QuickAccess cards={cards} />
       </main>
      <Footer />
    </div> 
  )
}